import Api from '@/services/Api';

const RECURSO = '/mobilidade';
export default {
    buscarCongestionamentosPorVia
};

function buscarCongestionamentosPorVia () {
    return Api.get(`${RECURSO}/congestionamentos`);
}